import { render, staticRenderFns } from "./itunes-search.vue?vue&type=template&id=20dae69e&scoped=true&"
import script from "./itunes-search.vue?vue&type=script&lang=js&"
export * from "./itunes-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dae69e",
  null
  
)

export default component.exports